module.exports = __webpack_public_path__ + "img/47_27.45788b50.png";